import React, { useContext } from 'react';
import { AppContext } from '../contexts/AppContext';

const ReportesScreen: React.FC = () => {
    const { sesionCaja, socios } = useContext(AppContext);

    const topSociosConsumo = [...socios].sort((a,b) => {
        const consumoA = sesionCaja?.ventas.filter(v => v.socio?.id === a.id).reduce((sum, v) => sum + v.total, 0) || 0;
        const consumoB = sesionCaja?.ventas.filter(v => v.socio?.id === b.id).reduce((sum, v) => sum + v.total, 0) || 0;
        return consumoB - consumoA;
    }).slice(0, 5);

    const topSociosPuntos = [...socios].sort((a,b) => b.puntos - a.puntos).slice(0, 5);

    return (
        <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-2xl font-bold mb-6 text-gray-800">Reportes</h2>
            
            <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="bg-gray-50 border border-gray-200 p-6 rounded-lg">
                        <h3 className="text-xl font-semibold mb-4 text-gray-700">Top 5 Socios por Consumo (Día)</h3>
                        <ul className="space-y-2">
                        {topSociosConsumo.map(s => {
                            const consumo = sesionCaja?.ventas.filter(v => v.socio?.id === s.id).reduce((sum, v) => sum + v.total, 0) || 0;
                            return (
                                <li key={s.id} className="flex justify-between text-sm">
                                    <span className="text-gray-600">{s.nombre} {s.apellido}</span>
                                    <span className="font-bold text-gray-800">${consumo.toLocaleString('es-AR')}</span>
                                </li>
                            )
                        })}
                        </ul>
                    </div>

                    <div className="bg-gray-50 border border-gray-200 p-6 rounded-lg">
                        <h3 className="text-xl font-semibold mb-4 text-gray-700">Top 5 Socios por Puntos Acumulados</h3>
                        <ul className="space-y-2">
                        {topSociosPuntos.map(s => (
                                <li key={s.id} className="flex justify-between text-sm">
                                    <span className="text-gray-600">{s.nombre} {s.apellido}</span>
                                    <span className="font-bold text-gray-800">{s.puntos} pts</span>
                                </li>
                        ))}
                        </ul>
                    </div>
                </div>

                <div className="bg-gray-50 border border-gray-200 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold mb-4 text-gray-700">Exportar Datos</h3>
                    <p className="text-gray-600 mb-4">Funcionalidad de exportación a CSV estará disponible en futuras versiones.</p>
                    <div className="flex gap-4">
                        <button className="bg-gray-300 text-gray-500 font-medium px-4 py-2 rounded cursor-not-allowed">Exportar Ventas</button>
                        <button className="bg-gray-300 text-gray-500 font-medium px-4 py-2 rounded cursor-not-allowed">Exportar Socios</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReportesScreen;